export const environment = {
  envName: 'M',
  production: true
};
